import { useGetDetailedMultiCurrencyBalancesQuery } from '@/api/v1';
import { useCustomer } from '@/hooks/useCustomer';
import { DetailedBalance } from '@/types/bankInfo';
import { CurrencyCodeType } from '@/types/currency';

export interface UseBalancesParams {
  readonly currencies: readonly CurrencyCodeType[];
  readonly beneficiaryId?: string;
}

export const useBalances = (
  params: UseBalancesParams,
): Partial<Record<CurrencyCodeType, DetailedBalance>> => {
  const { currencies, beneficiaryId } = params;
  const customer = useCustomer();
  const effectiveBeneficiaryId = beneficiaryId ?? customer.beneficiaryId;
  const { data: balances = [] } = useGetDetailedMultiCurrencyBalancesQuery(
    {
      beneficiaryId: effectiveBeneficiaryId,
      currency: currencies,
    },
    { skip: !effectiveBeneficiaryId },
  );

  const reducer = (
    mapped: Partial<Record<CurrencyCodeType, DetailedBalance>>,
    balance: DetailedBalance,
  ): Partial<Record<CurrencyCodeType, DetailedBalance>> => {
    return { ...mapped, [balance.currencyCode]: balance };
  };

  return balances.reduce(reducer, {});
};
